import apiClient from "QueryClient/axiosClient";

export const processLoan = (data) => {
  return apiClient.post("/finance/process-loan", data);
};

export const processDocument = (data) => {
  return apiClient.post("/finance/upload", data);
};

export const savePhoneNumber = (data) => {
  return apiClient.post("/finance/contact", data);
};

export const processUpload = (data) => {
  return apiClient.put("/finance/process-upload", data);
};

export const getLoanApplication = () => {
  return apiClient.get("/finance/loan-application");
};

export const deleteLoanApplication = () => {
  return apiClient.delete("/finance/loan-application");
};
